module.exports = {"330502001":"月河街道","330502002":"朝阳街道","330502003":"爱山街道","330502004":"飞英街道","330502005":"龙泉街道","330502006":"凤凰街道","330502007":"康山街道","330502008":"仁皇山街道","330502009":"滨湖街道","330502010":"龙溪街道","330502011":"杨家埠街道","330502012":"环渚街道","330502013":"湖东街道","330502100":"织里镇","330502101":"八里店镇","330502102":"妙西镇","330502104":"埭溪镇","330502105":"东林镇","330502200":"道场乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330502.json
// module id = 1089
// module chunks = 0